import { TriangleAlertIcon } from 'lucide-react';

export const WarningIcon = TriangleAlertIcon;
